module.exports = __webpack_public_path__ + "img/0153619d48ed0e8ca86c84d62b15cfdf.svg";